import axios from 'axios';

const apiPath = process.env.VUE_APP_API_PATH || 'http://localhost:3000'

console.log(process.env, apiPath);
const getURL = (path) => `${apiPath}/${path}`

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

export const getPosts = (limit, start) =>
  axios.get(getURL(`artworks`))

export const getPost = (postId) =>
  axios.get(getURL(`artworks/${postId}`))

export const createPost = (post) =>
  axios.post(getURL(`artworks`), post)

export const deletePost = (postId) =>
  axios.delete(getURL(`artworks/${postId}`))

export const publishPost = (postId) =>
  axios.put(
    getURL(`artworks/${postId}`),
    { 'status': 'published' }
  )

export const unpublishPost = (postId) =>
  axios.put(
    getURL(`artworks/${postId}`),
    { 'status': 'published' }
  )

export const updatePost = (postId, postDiff) =>
  axios.put( getURL(`artworks/${postId}`), postDiff)

export const postImage = (file) => {
  let fd = new FormData();
  fd.append('file',file)
  return axios.post(getURL(`files`), fd, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const deleteImage = (imageId) =>
  axios.delete(getURL(`files/${imageId}`))
